import React from "react";

export const SkillsSettings = () => <div>SkillsSettings</div>;
